var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    style: {
      color: "#b2c9de"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.708 6.808a2.029 2.029 0 0 0-2.842-.027L8.8 11.657a.505.505 0 0 0 .697.73l5.13-4.87a1 1 0 0 1 1.376 1.45l-5.129 4.87a2.505 2.505 0 0 1-3.46-3.621l5.067-4.877a4.029 4.029 0 0 1 5.642 5.752l-7.102 7.103a3.927 3.927 0 0 1-5.554 0l-.264-.264a3.571 3.571 0 0 1 .126-5.17l1.344 1.48a1.571 1.571 0 0 0-.056 2.276l.264.264a1.927 1.927 0 0 0 2.725 0l7.103-7.103a2.029 2.029 0 0 0 0-2.87Z",
    clipRule: "evenodd"
  })));
};
export default SvgAttachment;